// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1MQbN","image":"Header_image__1hpAb","name":"Header_name__3AGxU","info":"Header_info__2PCVA","infoRow":"Header_infoRow__2M7nE"};